export const USER_STATUS = "USER_STATUS";
export const USER_STATUS_ERROR_DATA = " USER_STATUS_ERROR_DATA";
export const USER_STATUS_HIDE_ERROR_DATA = "USER_STATUS_HIDE_ERROR_DATA";
export const USER_STATUS_START_LOADER = "   USER_STATUS_START_LOADER";
export const USER_STATUS_STOP_LOADER = "USER_STATUS_STOP_LOADER";
